import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

export class DatetimeStruct implements NgbDateStruct, NgbTimeStruct {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  second: number;

  constructor(other: DatetimeStruct | (NgbDateStruct & NgbTimeStruct)) {
    this.year = other.year || 0;
    this.month = other.month || 0;
    this.day = other.day || 0;
    this.hour = other.hour || 0;
    this.minute = other.minute || 0;
    this.second = other.second || 0;
  }

  /**
   * Checks if the current datetime is equal to another datetime.
   */
  equals(other?: DatetimeStruct | null): boolean {
    return (
      other != null &&
      this.year === other.year &&
      this.month === other.month &&
      this.day === other.day &&
      this.hour === other.hour &&
      this.minute === other.minute &&
      this.second === other.second
    );
  }

  /**
   * Checks if the current datetime is before another datetime.
   */
  before(other?: DatetimeStruct | null): boolean {
    if (!other) {
      return false;
    }

    if (this.year === other.year) {
      if (this.month === other.month) {
        if (this.day === other.day) {
          if (this.hour === other.hour) {
            if (this.minute === other.minute) {
              return this.second < other.second;
            } else {
              return this.minute < other.minute;
            }
          } else {
            return this.hour < other.hour;
          }
        } else {
          return this.day < other.day;
        }
      } else {
        return this.month < other.month;
      }
    } else {
      return this.year < other.year;
    }
  }

  /**
   * Checks if the current datetime is after another datetime.
   */
  after(other?: DatetimeStruct | null): boolean {
    if (!other) {
      return false;
    }

    if (this.year === other.year) {
      if (this.month === other.month) {
        if (this.day === other.day) {
          if (this.hour === other.hour) {
            if (this.minute === other.minute) {
              return this.second > other.second;
            } else {
              return this.minute > other.minute;
            }
          } else {
            return this.hour > other.hour;
          }
        } else {
          return this.day > other.day;
        }
      } else {
        return this.month > other.month;
      }
    } else {
      return this.year > other.year;
    }
  }
}
